<template>
  <v-col>
    <v-card>
      <v-card-title> Positionen </v-card-title>

      <v-data-table
        v-model="invoicedForm.positions"
        show-select
        :headers="positionTableHeaders"
        :items="positions"
        :item-class="positionBackground"
        dense
        item-key="id"
        :items-per-page="-1"
        hide-default-footer
        disable-sort
      >
        <template #[`item.data-table-select`]="{ isSelected, select, item }">
          <template
            v-if="
              item.position !== undefined &&
                !String(item.position).includes('.')
            "
          >
            <v-simple-checkbox :value="isSelected" @input="select" />
            <v-text-field
              v-model="item.invoice_number"
              label="Abrechnungsnr"
              dense
              hide-details
              @change="updateForm(select)"
            />
          </template>
        </template>
        <template #[`item.description`]="{ item }">
          {{ item.description }}
          <div v-if="item.zweck">
            {{ item.zweck }}
          </div>
          <v-menu v-if="item.purchaseItems && item.purchaseItems.length > 0" bottom left>
            <template #activator="{ on: onMenu, attrs: attrMenu }">
              <v-tooltip bottom>
                <template #activator="{ on: onTooltip, attr: attrTooltip }">
                  <v-icon
                    v-bind="{ ...attrMenu, ...attrTooltip }"
                    v-on="{ ...onMenu, ...onTooltip }"
                    v-text="'mdi-plus'"
                  />
                </template>
                <span>Einkaufsartikel</span>
              </v-tooltip>
            </template>
            <v-list dense>
              <v-list-item
                v-for="purchaseItem in item.purchaseItems"
                :key="`purchaseItem_${purchaseItem.id}`"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="purchaseItem.name" />
                  <v-list-item-subtitle>{{ purchaseItem.amount }} * {{ numberFormater.format(purchaseItem.price_per_piece) }}/Stk = {{ numberFormater.format(purchaseItem.price) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template #[`item.price`]="{ item }">
          {{ numberFormater.format(item.price) }}
        </template>
        <template #footer>
          <div>
            <v-btn type="submit" color="primary" @click="updateInvoiced">
              Speichern
            </v-btn>
          </div>
          <div class="text-end">
            Gesamtpreis monatlich: {{ numberFormater.format(wholePrices.mon) }}
            <br>
            Gesamtpreis einmalig: {{ numberFormater.format(wholePrices.k) }}
          </div>
        </template>
        <template #[`header.data-table-select`]="{}">
          <th>Abgerechnet</th>
        </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
// import { GChart } from 'vue-google-charts'

export default {
   components: {
      //   GChart
   },
   props: {
      positions: {
         type: Array,
         required: true,
      },
      invoicedPositions: {
         type: Array,
         required: true,
      },
      contract: {
         type: Number,
         required: true,
      },
   },
   data () {
      return {
         positionTableHeaders: [
            { text: 'Pos.', value: 'position' },
            { text: 'Beschreibung', value: 'description' },
            { text: 'Anz.', value: 'amount' },
            { text: 'Art', value: 'billing_type' },
            { text: 'Typ', value: 'product_type' },
            { text: 'Gesamtpreis netto', value: 'price' },
         ],
         numberFormater: new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
         }),
         invoicedForm: this.$inertia.form({
            positions: this.invoicedPositions,
         }),
      }
   },
   computed: {
      wholePrices () {
         const price = {
            mon: 0.0,
            k: 0.0,
         }
         this.positions
            .filter((pos) => pos.amount !== null)
            .forEach((pos) => {
               if (pos.billing_type === '1m') {
                  price.mon += parseFloat(pos.price)
               } else {
                  price.k += parseFloat(pos.price)
               }
            })
         return price
      },
   },
   methods: {
      positionBackground (pos) {
         return pos.position !== undefined && !String(pos.position).includes('.')
            ? 'grey'
            : 'transparent'
      },
      updateInvoiced () {
         this.invoicedForm.put(
            this.route('contract.update.invoiced', { contract: this.contract }),
            {
               onSuccess: (page) => {
                  console.log(this)
                  console.log(page)
                  this.invoicedForm.positions = this.invoicedPositions
                  this.invoicedForm.defaults()
                  this.invoicedForm.reset()
               },
            }
         )
      },
      updateForm (selectFun) {
         selectFun(false)
         setTimeout(function () {
            selectFun(true)
         }, 10)
      },
   },
}
</script>

<style>
</style>
